module.exports = __webpack_public_path__ + "static/media/7ICJ1.7141b39a.jpg";